import {createApp as createVueApp} from 'vue';
import {createPinia} from 'pinia';
import {createORM} from "pinia-orm";

import {FontAwesomePluginVue} from './plugins/FontAwesome.js';
import {GraphqlPluginVue, GraphqlPluginPinia} from './plugins/GraphQL.js';
import {ToasterPluginVue, ToasterPluginPinia} from './plugins/Toaster.js';
import {DefinitionsPlugin} from "./plugins/Definition.js";

export function createApp(App) {
	createVueApp(App)
		.use(createPinia().use(createORM()).use(GraphqlPluginPinia).use(ToasterPluginPinia))
		.use(FontAwesomePluginVue)
		.use(GraphqlPluginVue)
		.use(ToasterPluginVue)
		.use(DefinitionsPlugin)
		.mount('#' + __DATAPAS_APP_NAME__);
}